import { isNil } from "lodash-es";
import type { FieldConfig, VariableConfig } from "../../fields/types";
import type { SubformDto } from "../../services/ApiService";
import type { SubformEmailConfiguration } from "../../state/formVersion";
import { parseStringTemplate } from "../stringTemplateUtil";
import type FieldId from "../../fields/FieldId";

export const toSubformEmailConfiguration = (
  subformDto: SubformDto,
  subformFields: FieldConfig[],
  variables: VariableConfig[],
): SubformEmailConfiguration | undefined => {
  const trigger = subformDto.triggers?.at(0);
  return isNil(trigger)
    ? undefined
    : {
        content: parseStringTemplate(trigger.content, subformFields, variables),
        pinFieldsToAttach:
          trigger.configuration.attachments
            .map((dataName) => dataNameToFieldId(dataName, subformFields))
            .filter(removeUndefined) ?? [],
        pdfContent: trigger.pdfContent ?? "",
        simpleMode: trigger.configuration.simpleMode ?? true,
        hideNoValues: trigger.configuration.hideNoValues ?? false,
        horizontalOrientation: trigger.configuration.horizontalOrientation ?? false,
      };
};

const dataNameToFieldId = (dataName: string, fields: FieldConfig[]): FieldId | undefined =>
  fields.find((field) => field.properties.data_name === dataName)?.uid;

const removeUndefined = <T>(item: T): item is Exclude<T, undefined> => item !== undefined;
